/**
 * חצרות — האפליקציה הראשית
 * ================================================================
 * ניתוב פנימי (בלי react-router — פשוט state):
 *   'auth'   — התחברות/הרשמה
 *   'lobby'  — רשימת משחקים
 *   'round'  — משחק פעיל
 */

import { useEffect, useState } from 'react';
import { isAuthenticated } from './api/client.js';
import { AuthScreen } from './screens/AuthScreen.js';
import { LobbyScreen } from './screens/LobbyScreen.js';
import { RoundScreen } from './screens/RoundScreen.js';

type View =
  | { name: 'auth' }
  | { name: 'lobby' }
  | { name: 'round'; roundId: string };

export function App() {
  const [view, setView] = useState<View>({ name: 'auth' });

  useEffect(() => {
    // התחל ב-lobby אם יש token
    if (isAuthenticated()) {
      setView({ name: 'lobby' });
    }
  }, []);

  if (view.name === 'auth') {
    return <AuthScreen onSuccess={() => setView({ name: 'lobby' })} />;
  }

  if (view.name === 'lobby') {
    return (
      <LobbyScreen
        onEnterRound={(id) => setView({ name: 'round', roundId: id })}
        onLogout={() => setView({ name: 'auth' })}
      />
    );
  }

  return (
    <RoundScreen
      roundId={view.roundId}
      onLeave={() => setView({ name: 'lobby' })}
    />
  );
}
